import { enumEntityModelCode } from '@data-layer/enums/entities';

export const ENTITY_INFO_DESC = {
  SH: {
    code: enumEntityModelCode.SHIPPER,
    imgSrc: 'seller',
    title: 'INFO.SH.TITLE_LCL',
    titleDesktop: 'INFO.SH.TITLE_LCL',
    subTitle: 'INFO.SH.ADD_NEW',
    addNew: 'INFO.SH.ADD_NEW',
  },
  BY: {
    code: enumEntityModelCode.BUYER,
    imgSrc: 'buyer',
    title: 'INFO.BY.TITLE_LCL',
    titleDesktop: 'INFO.BY.TITLE_LCL',
    addNew: 'INFO.BY.ADD_NEW_LCL',
    subTitle: 'INFO.BY.SUB_TITLE_LCL',
  },
  NP: {
    code: enumEntityModelCode.NOTIFY_PARTY,
    imgSrc: 'notify_party',
    title: 'INFO.NP.TITLE_LCL',
    titleDesktop: 'INFO.NP.TITLE_LCL',
    addNew: 'INFO.NP.ADD_NEW_LCL',
    subTitle: 'INFO.NP.SUB_TITLE',
    subTitleHint: 'INFO.NP.SUB_TITLE_HINT',
  },
};
